import { render, staticRenderFns } from "./EmailCompose.vue?vue&type=template&id=3c470498&scoped=true&"
import script from "./EmailCompose.vue?vue&type=script&lang=js&"
export * from "./EmailCompose.vue?vue&type=script&lang=js&"
import style0 from "./EmailCompose.vue?vue&type=style&index=0&id=3c470498&lang=scss&scoped=true&"
import style1 from "./EmailCompose.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./EmailCompose.vue?vue&type=style&index=2&id=3c470498&lang=scss&scoped=true&"
import style3 from "./EmailCompose.vue?vue&type=style&index=3&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c470498",
  null
  
)

export default component.exports